import { render, staticRenderFns } from "./SettingsTemplate.vue?vue&type=template&id=2a6d9ffc&scoped=true&"
import script from "./SettingsTemplate.vue?vue&type=script&lang=js&"
export * from "./SettingsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTemplate.vue?vue&type=style&index=0&id=2a6d9ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d9ffc",
  null
  
)

export default component.exports